import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import PrivacyPageUI from './PrivacyPageUI.js'

class PrivacyPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      privacy: null,
      messageList: null
    }
  }

  render() {
    return (
      <PrivacyPageUI
        context={this.props.context}
        privacy={this.state.privacy}
        messageList = {this.state.messageList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getContent(context)
    this.getMessages(context)
    document.body.classList.add('sdp')
  }

  getContent(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/contents/privacy_policy/locale/${context.locale}`,
      cacheKey: CacheKeys.Contents('privacy', context.locale),
      callback: this.getContentCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getContentCallback = (response) => {
    console.log('-> GET', response.publicURL);
    fetch(response.publicURL)
    .then((response) => {
      return response.text()
    })
    .then((text) => {
      console.log('<- GET', response.publicURL, /*text*/);
      this.setState({privacy : text})
    })
  }

  getMessages(context) {
    let arr = [
      'c_privacy',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_privacy', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default PrivacyPageSF
